var minDate = 10;
var maxDate = 14;

if (document.querySelector('.estimated_value_min_delivery_day') && document.querySelector('.estimated_value_min_delivery_day').textContent.trim() !== '') {
  minDate = parseInt(document.querySelector('.estimated_value_min_delivery_day').textContent.trim());
}
if (document.querySelector('.estimated_value_max_delivery_day') && document.querySelector('.estimated_value_max_delivery_day').textContent.trim() !== '') {
  maxDate = parseInt(document.querySelector('.estimated_value_max_delivery_day').textContent.trim());
}

var fromDate = new Date();
fromDate.setDate(fromDate.getDate() + minDate);
while (fromDate.getDay() === 6 || fromDate.getDay() === 0) {
  fromDate.setDate(fromDate.getDate() + 1);
}

var toDate = new Date();
toDate.setDate(toDate.getDate() + maxDate);
while (toDate.getDay() === 6 || toDate.getDay() === 0) {
  toDate.setDate(toDate.getDate() + 1);
}

function formatDate(date) {
  var monthNames = String((window.EVAMATS_I18N || {}).monthsShort || '').split(',');
  if (monthNames.length !== 12) {
    monthNames = [];
    for (var m = 0; m < 12; m++) monthNames.push(new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: 'short' }).format(new Date(2020, m, 1)));
  }

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var month = (monthIndex + 1).toString().padStart(2, '0');
  return monthNames[monthIndex] + " " + day + "/" + month;
}

var fromDateElement = document.getElementById('fromDate');
var toDateElement = document.getElementById('toDate');

if (fromDateElement) {
  fromDateElement.innerHTML = formatDate(fromDate);
}
if (toDateElement) {
  toDateElement.innerHTML = formatDate(toDate);
}